module.exports = __webpack_public_path__ + "img/6-diccionary.876c52a7.svg";